export default __webpack_public_path__ + "static/media/flame-success.50b5eac8.png";